import {
  fetchAllDevicesWatch, reFetchAllDevicesWatch, fetchDevicesByUserIdWatch, reFetchDevicesByUserIdWatch,
  registerDeviceWatch
} from './device';
import { fetchDeviceWetLogsWatch } from './log';
import { insertUserWatch, loginUserWatch } from './user';

export default function* rootSaga() {
  yield [
    fetchAllDevicesWatch(),
    reFetchAllDevicesWatch(),
    fetchDevicesByUserIdWatch(),
    reFetchDevicesByUserIdWatch(),
    fetchDeviceWetLogsWatch(),
    insertUserWatch(),
    registerDeviceWatch(),
    loginUserWatch()
  ]
}


// WEBPACK FOOTER //
// ./src/sagas/rootSaga.js